// Do not add "use client". Imported by RSCLoggedOutFooter.tsx
import type { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { localeStringToLocaleKey } from "@faire/web/common/consts/TWO_TO_THREE_LETTER_LANGUAGE_CODE";
import { Flex, HorizontalLine } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { cn } from "@faire/web/tools/cn";
import React from "react";

import { FooterSection } from "./FooterSection";
import { LegalLinks } from "./LegalLinks";

export const FooterBase: React.FC<{
  ref?: React.Ref<HTMLDivElement>;
  className?: string;
  noTopBorder?: boolean;
  locale: string;
  isLoggedInRetailer: boolean;
  retailerOrSessionCountry: keyof typeof ISO3166Alpha3 | undefined;
  adyenEUPaymentMethodsIcons: string[] | null;
  children: React.ReactNode;
}> = ({
  ref,
  className,
  noTopBorder,
  locale,
  isLoggedInRetailer,
  retailerOrSessionCountry,
  adyenEUPaymentMethodsIcons,
  children,
}) => {
  return (
    <div
      ref={ref}
      className={cn(
        "position-relative bg-core-surface-inverse w-full",
        className
      )}
    >
      {noTopBorder ? null : <HorizontalLine />}
      <footer
        className={cn(
          "mx-auto flex w-full flex-col justify-between self-stretch overflow-auto px-4 py-8 md:px-6 lg:p-12 2xl:p-20"
        )}
      >
        <Flex
          justify={{
            mobileAndAbove: "flex-start",
            tabletAndAbove: "space-between",
          }}
          align="flex-start"
          direction={{
            mobileAndAbove: "column",
            tabletAndAbove: "row",
          }}
        >
          {children}

          <HorizontalLine
            width="100vw"
            margin="0 -16px"
            className="md:hidden"
          />
          <FooterSection
            locale={locale}
            isLoggedInRetailer={isLoggedInRetailer}
            retailerOrSessionCountry={retailerOrSessionCountry}
          />
        </Flex>
        <Spacer size={{ mobileAndAbove: "2x", tabletAndAbove: "4x" }} />
        <LegalLinks
          country={retailerOrSessionCountry}
          localeKey={localeStringToLocaleKey(locale)}
          adyenEUPaymentMethodsIcons={adyenEUPaymentMethodsIcons}
        />
        <Spacer size={{ mobileAndAbove: "7x", tabletAndAbove: "2x" }} />
      </footer>
    </div>
  );
};
